import { dump } from 'js-yaml';

export function exportYamlFile(
  data: {
    prompt: {
      promptName: String;
      promptVersion: number;
      businessGroup: String;
      creation_date: string;
      author: String;
      roles: [];
      variables: [];
      llmTestedWith: String;
      promptDescription: String;
      systemPrompt: String;
      usageExample: String;
      totalVersions: String;
    };
    roles: [];
    variables: [];
  },
  filename = 'data.yaml'
) {
  const {
    promptName = '',
    promptVersion = 0,
    businessGroup = '',
    creation_date = '',
    author = '',
    llmTestedWith = '',
    promptDescription = '',
    systemPrompt = '',
    usageExample = '',
    totalVersions = ''
  } = data?.prompt;

  const { roles = [], variables = [] } = data;

  const formattedData = {
    name: promptName,
    version: promptVersion,
    llmTestedWith: llmTestedWith,
    is_prompt_type_private: 'True/False , any value',
    is_interaction_type_single: 'True/False , any value',
    promptDescription: promptDescription,
    systemPrompt: systemPrompt,
    // usageExample: usageExample,
    // totalVersions: totalVersions,
    roles: roles,
    variables: variables,
    //
    template: 'Summarize {{application_data}} with focus on {{region}}',
    parameters: [
      {
        name: 'application_data',
        type: 'string',
        required: true,
        description: 'Raw sales data to summarize'
      },
      {
        name: 'region',
        type: 'string',
        required: false,
        default: 'Europe',
        description: 'Geographical region of focus'
      }
    ],
    metadata: {
      tags: businessGroup,
      created_by: author,
      created_at: creation_date,
      success_rate: 0.87,
      feedback_score: 4.5
    }
  };

  const yamlStr = dump(formattedData);
  const blob = new Blob([yamlStr], { type: 'text/yaml' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
